/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// Add class to body if page is scrolled
	function scrollChecker() {
		var scroll = jQuery(window).scrollTop();
		var stickyMenu = jQuery('.header-wrap');
		if(scroll > stickyMenu.outerHeight()) {
			jQuery('body').addClass("scrolled");
		} else {
			jQuery('body').removeClass("scrolled");
		}
	}

	jQuery(window).scroll(function (event) {
    scrollChecker();
	});

	scrollChecker();

	// Toggle search bar
	jQuery('.toggle-search').click(function(e) {
		var search = jQuery('.search-form-wrap');
		var searchField = search.find('input');
		var $this = jQuery(this).find('.fas');
		searchField.focus();
		search.toggleClass('active');
		if($this.hasClass('fa-search')) {
			$this.removeClass('fa-search');
			$this.addClass('fa-search-minus');
		} else {
			$this.removeClass('fa-search-minus');
			$this.addClass('fa-search');
		}
		e.preventDefault();
	});

	jQuery('.activate-share').click(function(e) {
		var parent = jQuery(this).closest('.social-share');
		parent.toggleClass('active');
		e.preventDefault();
	});

	// add class when div have horizontal scroll
	// function detectScrollBar(element) {
	// 	var siblings = element.find('li');
	// 	var siblingsWidth = 0;
	// 	siblings.each(function() {
	// 		siblingsWidth += jQuery(this).outerWidth();
	// 	});
	// 	var parentWidth = element.parent().outerWidth();
	// 	if(siblingsWidth > parentWidth) {
	// 		element.addClass('scroll-bar');
	// 	} else {
	// 		element.removeClass('scroll-bar');
	// 	}
	// }
	// detectScrollBar(jQuery('.sub-menu'));
	//
	//
	// var resizeTimer;
	// jQuery(window).on('resize', function(e) {
	//   clearTimeout(resizeTimer);
	//   resizeTimer = setTimeout(function() {
	// 		detectScrollBar(jQuery('.sub-menu'));
	//   }, 250);
	// });
});